import { CanActivateFn } from '@angular/router';
import { permissionGuard } from './permission.guard';

export const reportsPermissionGuard: CanActivateFn = permissionGuard('CanReadReports');

